import { useContext } from 'react';

import { EventFormContext } from './event-form-context';

export const useOpenCreateEventPopup = () => {
  const { onCreateEvent } = useContext(EventFormContext);

  return onCreateEvent;
};
